var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#00BED9",
    d: "M9.2 7.4c-.8 0-1.6.6-1.8 1.4s.2 1.7.9 2.1 1.7.2 2.2-.4h5.3c.4-2-.2-4-1.5-5.6-1.3-1.5-3.2-2.4-5.2-2.4V0C4.1 0 0 4.1 0 9.2h2.5c0 3 2 5.6 4.8 6.5 2.9.9 6-.3 7.6-2.8h-3.5c-1.3.8-3 .8-4.3.1-1.4-.8-2.2-2.2-2.2-3.7H2.5c0-3.7 3-6.8 6.8-6.8V5c1.9 0 3.6 1.3 4.1 3.1h-2.8c-.3-.5-.8-.7-1.4-.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.d25dfe3d2d7711b07efd97fb47593f18.svg";
export { ForwardRef as ReactComponent };